
import { defineComponent } from 'vue';

import CookieNotice from '@/components/shared/CookieNotice/CookieNotice.vue';

export default defineComponent({
  name: 'App',

  components: {
    CookieNotice,
  },
});
